<f-dropdown caLocalizationScope="navigation" [icon]="icon" [btnStyle]="btnStyle" [tooltip]="tooltip | caLocalize">
  <f-list>
    <f-list-item
      *ngFor="let item of list; let index = index"
      fDropdownItem
      (click)="itemClick.emit(index)"
      caLocalizationScope="navigation"
    >
      {{ item.localizationKey | caLocalize }}
    </f-list-item>
  </f-list>
</f-dropdown>
